import { createSelector } from 'reselect';

import { RootState } from '../store';
import { ProjectState } from './project.reducer';

export const selectProjectReducer = (state: RootState): ProjectState => state.project;

export const selectProjectSelected = createSelector(
    selectProjectReducer,
    (project) => project.projectSelected
);

export const selectNodeProjectSelected = createSelector(
    selectProjectReducer,
    (project) => project.nodeProjectSelected
);

export const selectMyProjects = createSelector(
    selectProjectReducer,
    (project) => project.myProjects
);